import { render } from "./SectionTwelve.vue?vue&type=template&id=36ef0d9a&scoped=true"
import script from "./SectionTwelve.vue?vue&type=script&lang=js"
export * from "./SectionTwelve.vue?vue&type=script&lang=js"

import "./SectionTwelve.vue?vue&type=style&index=0&id=36ef0d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ef0d9a"]])

export default __exports__